import type { Template } from "@/types";

export const LA_06_H6_V0: Template[] = [
    {
        id: "la-06-h6v0-01",
        name: "LA 01 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_01.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 107, y: 41, width: 440, height: 294, rotation: 0, imageRotation: 0 },
            { id: "2", x: 107, y: 343, width: 217, height: 157, rotation: 0, imageRotation: 0 },
            { id: "3", x: 332, y: 343, width: 216, height: 157, rotation: 0, imageRotation: 0 },
            { id: "4", x: 803, y: 41, width: 440, height: 294, rotation: 0, imageRotation: 0 },
            { id: "5", x: 803, y: 343, width: 217, height: 157, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1028, y: 343, width: 216, height: 157, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-02",
        name: "LA 02 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 107, y: 41, width: 440, height: 294, rotation: 0, imageRotation: 0 },
            { id: "2", x: 107, y: 343, width: 217, height: 157, rotation: 0, imageRotation: 0 },
            { id: "3", x: 332, y: 343, width: 216, height: 157, rotation: 0, imageRotation: 0 },
            { id: "4", x: 803, y: 206, width: 440, height: 293, rotation: 0, imageRotation: 0 },
            { id: "5", x: 803, y: 41, width: 217, height: 157, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1028, y: 41, width: 216, height: 157, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-03",
        name: "LA 03 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_03.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 206, y: 0, width: 264, height: 175, rotation: 0, imageRotation: 0 },
            { id: "2", x: 206, y: 183, width: 264, height: 175, rotation: 0, imageRotation: 0 },
            { id: "3", x: 206, y: 366, width: 264, height: 175, rotation: 0, imageRotation: 0 },
            { id: "4", x: 882, y: 0, width: 264, height: 175, rotation: 0, imageRotation: 0 },
            { id: "5", x: 882, y: 183, width: 264, height: 175, rotation: 0, imageRotation: 0 },
            { id: "6", x: 882, y: 366, width: 264, height: 175, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-04",
        name: "LA 04 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_04.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 38, y: 26, width: 338, height: 240, rotation: 0, imageRotation: 0 },
            { id: "2", x: 38, y: 274, width: 338, height: 239, rotation: 0, imageRotation: 0 },
            { id: "3", x: 384, y: 26, width: 703, height: 487, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1095, y: 26, width: 220, height: 157, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1095, y: 192, width: 220, height: 157, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1095, y: 357, width: 220, height: 156, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-05",
        name: "LA 05 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_05.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 37, y: 26, width: 338, height: 240, rotation: 0, imageRotation: 0 },
            { id: "2", x: 37, y: 274, width: 338, height: 239, rotation: 0, imageRotation: 0 },
            { id: "3", x: 383, y: 26, width: 220, height: 157, rotation: 0, imageRotation: 0 },
            { id: "4", x: 383, y: 191, width: 220, height: 157, rotation: 0, imageRotation: 0 },
            { id: "5", x: 383, y: 356, width: 220, height: 157, rotation: 0, imageRotation: 0 },         
            { id: "6", x: 611, y: 26, width: 703, height: 487, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "la-06-h6v0-06",
        name: "LA 06 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_06.png",
        size: [1352, 541],
        style: {},
        slots: [        
            { id: "1", x: 38, y: 27, width: 220, height: 157, rotation: 0, imageRotation: 0 },
            { id: "2", x: 38, y: 192, width: 220, height: 157, rotation: 0, imageRotation: 0 },
            { id: "3", x: 38, y: 357, width: 220, height: 157, rotation: 0, imageRotation: 0 },
            { id: "4", x: 265, y: 27, width: 338, height: 240, rotation: 0, imageRotation: 0 },
            { id: "5", x: 265, y: 275, width: 338, height: 240, rotation: 0, imageRotation: 0 },
            { id: "6", x: 610, y: 27, width: 704, height: 487, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-07",
        name: "LA 07 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_07.png",
        size: [1352, 541],
        style: {},
        slots: [         
            { id: "1", x: 103, y: 49, width: 318, height: 218, rotation: 0, imageRotation: 0 },
            { id: "2", x: 103, y: 275, width: 318, height: 217, rotation: 0, imageRotation: 0 },
            { id: "3", x: 428, y: 49, width: 618, height: 443, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1053, y: 49, width: 195, height: 143, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1053, y: 200, width: 195, height: 142, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1053, y: 350, width: 195, height: 142, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-08",
        name: "LA 08 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_08.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 105, width: 222, height: 162, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 275, width: 222, height: 162, rotation: 0, imageRotation: 0 },
            { id: "3", x: 229, y: 105, width: 443, height: 332, rotation: 0, imageRotation: 0 },
            { id: "4", x: 680, y: 105, width: 222, height: 162, rotation: 0, imageRotation: 0 },
            { id: "5", x: 680, y: 275, width: 222, height: 162, rotation: 0, imageRotation: 0 },
            { id: "6", x: 909, y: 105, width: 443, height: 332, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-09",
        name: "LA 09 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_09.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 105, width: 443, height: 332, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 451, y: 105, width: 222, height: 162, rotation: 0, imageRotation: 0 },
            { id: "3", x: 451, y: 275, width: 222, height: 162, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 105, width: 221, height: 162, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 275, width: 221, height: 162, rotation: 0, imageRotation: 0 },
            { id: "6", x: 909, y: 105, width: 443, height: 332, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-10",
        name: "LA 10 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_10.png",
        size: [1352, 541],
        style: {},
        slots: [          
            { id: "1", x: 0, y: 104, width: 222, height: 162, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 274, width: 222, height: 162, rotation: 0, imageRotation: 0 },
            { id: "3", x: 230, y: 104, width: 442, height: 332, rotation: 0, imageRotation: 0 },
            { id: "4", x: 680, y: 104, width: 442, height: 332, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1130, y: 104, width: 222, height: 162, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1130, y: 274, width: 222, height: 162, rotation: 0, imageRotation: 0 }
        ],
    }
];